import { render, staticRenderFns } from "./MemberMoveGroup.vue?vue&type=template&id=785bb4b6"
import script from "./MemberMoveGroup.vue?vue&type=script&lang=js"
export * from "./MemberMoveGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports